var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReqPayoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_727_2053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_727_2053)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 20,
    height: 20,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_727_2053",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_727_2053",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAXlJREFUSInt1LtLnEEUBfCfr4CPgGmCnQGLrUJMEYiFsuJa+SjshMUi+Q8kRewtLOxTpU+TSkvBoChaiaiBWFhHRFLERDCJptgrjptdv/UBaTww3Lmvc3buzLfc43+jLtnnMISmW3L+wjx202AOP3F2R+tHcKoPgVE0oyNOdZvVgZbg1BgCrWH3w/ahFy/RkDGSP1jDMpYSjtZUoBwTeJ1BnGIY70PgEs5HdBB2HAV8wJuI9as+jv6omYyeQnCknOARPqt8Ya+u+OX5Kj07aOdiRN/Qjed4GLFnmMVe+E/xNvYz2EqEJhP/OzZwkgqIwHri/072bVjAqdJoBtCV5DfwqdIRq11yOXJ4jLEQ+BixTNQq8EXp+b0L/2vEXmQ11mcVBI6UXshCrEGlrzUTV53gQdgerGIbxbJ8T1nttVB08ew20ZnkOiN2ni/+010D8tE8hUMsJrnFiE1FTb4aSS2X/AQrGMF0Ij4XuRsjh2PZf83Hanyy96iIv51SaKY/mVwnAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqPayoutIcon);
export default __webpack_public_path__ + "static/media/req_payout_icon.93eae60b83aa38a7283b034f2aec0bc8.svg";
export { ForwardRef as ReactComponent };